import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button, Tooltip, Tabs, Icon } from "antd";
import styled from "react-emotion";

import ImagesList from "./ImagesList";
import UploadImagesButton from "./UploadImagesButton";
import WebsiteUrl from "../WebsiteUrl";
import * as actions from "../../../actions";

const websiteURLImage = require("../../../images/websiteUrl.png");
const stockImage = require("../../../images/stockImages.png");
// -------------------------------------- Styles ----------------------
const Container = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  flexWrap: "wrap",
  img: {
    margin: "auto"
  }
});

const ImagesWrapper = styled("div")({
  width: "90%",
  margin: "auto"
});

const { TabPane } = Tabs;

class UploadModal extends Component {
  handleCheck(uid) {
    this.props.updateImageState(uid, false);
    this.props.removeCroppedImage(uid);
    this.props.removeCroppedLogo(uid);
  }

  renderTitle = () => (
    <div>
      <p>Upload files that meet or can be cropped to our recommended sizes:</p>
      <p>Image</p>
      <p>Landscape (1.91:1): 1200 × 628 (min required: 600 × 314)</p>
      <p>Logo </p>
      <p>Square: 1200 × 1200 (min required: 128 × 128)</p>
    </div>
  );

  renderUpload = () => {
    const { images } = this.props;
    return (
      <ImagesWrapper>
        <p>
          Upload images and logos that meet or can be cropped to our
          requirements {"  "}
          <Tooltip title={this.renderTitle()}>
            <Icon type="info-circle" />
          </Tooltip>
        </p>
        <Container>
          <UploadImagesButton
            images={images}
            onAddingImage={this.props.addImage}
            handleImagePreview={this.props.handleImagePreview}
            handleRemove={this.props.handleRemove}
          />
          <ImagesList
            images={images.filter(image => image.type === "upload")}
            onChecked={uid => this.handleCheck(uid)}
          />
        </Container>
      </ImagesWrapper>
    );
  };

  renderWebsiteUrl = () => {
    const { images } = this.props;
    const filteredImages = images.filter(image => image.type === "website");
    return (
      <React.Fragment>
        <div style={{ width: "90%", margin: "auto" }}>
          <p>
            Scan your website for images and logos. Images that meet the
            requirements will be shown.
          </p>
          <WebsiteUrl
            placeholder="Enter your URL"
            url="https://image-extractor.testing.mcagrid.com/extract"
            buttonTitle="Scan"
          />
        </div>
        <ImagesWrapper>
          <Container>
            {filteredImages.length ? (
              <ImagesList
                images={filteredImages}
                onChecked={uid => this.handleCheck(uid)}
              />
            ) : (
              <img src={websiteURLImage} alt="websiteUrl" />
            )}
          </Container>
        </ImagesWrapper>
      </React.Fragment>
    );
  };

  renderStockImages = () => {
    const { images } = this.props;
    const filteredImages = images.filter(image => image.type === "stockImages");
    return (
      <React.Fragment>
        <div style={{ width: "90%", margin: "auto" }}>
          <p>Find images related to your website, products or services.</p>
          <WebsiteUrl
            topic={true}
            placeholder="Enter words or phrases related to your business"
            buttonTitle="Search"
            url="https://image-extractor.testing.mcagrid.com/recommend?topic="
          />
        </div>
        <ImagesWrapper>
          <Container>
            {filteredImages.length ? (
              <ImagesList
                images={filteredImages}
                onChecked={uid => this.handleCheck(uid)}
              />
            ) : (
              <img src={stockImage} alt="stockImages" />
            )}
          </Container>
        </ImagesWrapper>
      </React.Fragment>
    );
  };

  render() {
    const {
      onCancel,
      croppedImages,
      headlines,
      descriptions,
      businessName
    } = this.props;

    return (
      <Modal
        visible={true}
        onCancel={onCancel}
        width="850px"
        bodyStyle={{ height: "520px", maxHeight: "650px", overflow: "auto" }}
        footer={[
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>,
          <Button
            key="Save"
            type="primary"
            onClick={() => {
              this.props.createPreviewImages(
                croppedImages,
                headlines,
                descriptions,
                businessName
              );
              onCancel();
            }}
          >
            Save
          </Button>
        ]}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="SCAN WEBSITE" key="1">
            {this.renderWebsiteUrl()}
          </TabPane>
          <TabPane tab="UPLOAD" key="2">
            {this.renderUpload()}
          </TabPane>
          <TabPane tab="STOCK IMAGES" key="3">
            {this.renderStockImages()}
          </TabPane>
        </Tabs>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  images: state.images,
  croppedImages: state.croppedImages,
  headlines: state.headlines,
  descriptions: state.descriptions,
  businessName: state.businessName[0]
});

export default connect(
  mapStateToProps,
  actions
)(UploadModal);
